/* Desktop mega menu: open on hover instead of click only.
   - Applies only to devices with a fine hover pointer; touch keeps tap-to-toggle.
   - While a panel is hover-opened, clicking the parent item follows the parent
     link (when it has one) instead of collapsing the panel.
   - Keyboard behavior (Enter to toggle, focusout to close) is unchanged. */
(() => {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const CLOSE_DELAY_MS = 150;

  document.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
    const details = menu.querySelector('details.mega-menu');
    const summary = details && details.querySelector('summary');
    if (!details || !summary) return;

    let closeTimer = null;
    let openedByHover = false;

    const open = () => {
      window.clearTimeout(closeTimer);
      if (details.open) return;
      document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach((other) => {
        if (other !== details) other.removeAttribute('open');
      });
      openedByHover = true;
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    };

    const scheduleClose = () => {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        openedByHover = false;
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      }, CLOSE_DELAY_MS);
    };

    menu.addEventListener('mouseenter', () => {
      if (canHover.matches) open();
    });
    menu.addEventListener('mouseleave', () => {
      if (canHover.matches) scheduleClose();
    });

    summary.addEventListener('click', (event) => {
      if (!canHover.matches || !details.open || !openedByHover) return;
      event.preventDefault();
      if (summary.dataset.url) window.location.href = summary.dataset.url;
    });
  });
})();
